// extracted by mini-css-extract-plugin
export default {"flex-container":"styles_flex-container__DOBf8","attach-assistant-btn":"styles_attach-assistant-btn__qKJOP"};